module.exports = __webpack_public_path__ + "img/1m.cb2b2afd.jpg";